import React, { useState, useEffect } from "react";
import Skeleton from "react-loading-skeleton";
import { useNavigate, useParams } from "react-router-dom";

import ProjectHeader from "../../Partials/ProjectHeader";
import ProjectNav from "../../Partials/ProjectNav";
import ButtonSubmit from "../../../../components/Atomes/Buttons/ButtonSubmit";
import PopupConfirmPaymentOption from "./Popup/PopupConfirmPaymentOption";

import { ProjectStageService } from "../../../../services/ProjectStageService";

const ProjectStagePaymentOption = () => {
  const navigate = useNavigate();
  const { projectId } = useParams();
  const [projectStepVerificator, setProjectStepVerificator] = useState(false);
  const [project, setProject] = useState(null);
  const [isSinglePaymentSelected, setIsSinglePaymentSelected] = useState(false);
  const [isMultiplePaymentSelected, setIsMultiplePaymentSelected] =
    useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showConfirmPopup, setShowConfirmPopup] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    getProjectData();
  }, []);

  const getProjectData = async () => {
    let projectInfos = await ProjectStageService.getSingleProject(projectId);
    if (
      projectInfos.stage === "COM_deposit" &&
      (projectInfos.isSinglePayment === null ||
        projectInfos.isSinglePayment === undefined)
    ) {
      setProject(projectInfos);
      setProjectStepVerificator(true);
    } else {
      navigate("/projet/" + projectId, { replace: true });
    }
  };

  const handleSinglePaymentChange = () => {
    setIsSinglePaymentSelected(!isSinglePaymentSelected);
    setIsMultiplePaymentSelected(false);
  };

  const handleMultiplePaymentChange = () => {
    setIsMultiplePaymentSelected(!isMultiplePaymentSelected);
    setIsSinglePaymentSelected(false);
  };

  const handleSubmit = () => {
    if (!isSinglePaymentSelected && !isMultiplePaymentSelected) {
      return;
    }
    setShowConfirmPopup(true);
  };

  const handleClosePopup = () => {
    setShowConfirmPopup(false);
  };

  const handleConfirmSubmit = async () => {
    setIsSubmitting(true);
    try {
      let request;
      if (isSinglePaymentSelected) {
        request = await ProjectStageService.postFinalInvoice(projectId);
      } else {
        request = await ProjectStageService.postDeposit(projectId);
      }

      if (
        request.status === 200 ||
        request.status === 201 ||
        request.status === 204
      ) {
        navigate("/projet/" + projectId, { replace: true });
      } else {
        setIsSubmitting(false);
        setShowConfirmPopup(false);
      }
    } catch (error) {
      console.error(
        "Erreur lors de la sauvegarde de l'option de paiement:",
        error
      );
      setIsSubmitting(false);
      setShowConfirmPopup(false);
    }
  };

  return (
    <>
      {!projectStepVerificator ? (
        <>
          <Skeleton height={300} />
          <Skeleton height={40} />
        </>
      ) : (
        <>
          <ProjectHeader project={project} />

          <section className="project-container">
            <ProjectNav
              step={1}
              visit={project.visitType}
              paymentType={
                project.isSinglePayment === true ? "single" : "multiple"
              }
            />
            <div className="project-container-step__header">
              <h3 className="color-black">
                Choisissez votre option de paiement
              </h3>
              <div className="text-primary">
                <p className="text-primary">
                  Le règlement de votre prestation peut se faire de deux
                  manières :
                </p>
                <p className="text-primary">
                  1. En un seul paiement : <strong>100 %</strong>  du montant du devis que vous avez
                  signé. Une fois votre paiement effectué, vous pourrez accéder
                  à votre dossier d'étude structure pour le télécharger dès que
                  votre ingénieur chargé(e) d'affaires l'aura déposé sur votre
                  espace personnel en ligne (facture finale).
                </p>
                <p className="text-primary">2. En deux paiements :</p>
                <ul style={{ marginLeft: "30px", marginTop: "10px", listStyleType: "disc" }}>
                  <li className="text-primary">
                    Premier règlement : <strong>50 %</strong> du montant du devis lors de la
                    validation de votre commande (facture d'acompte).
                  </li>
                  <li className="text-primary">
                    Deuxième règlement : <strong>50 %</strong> avant la réception de votre dossier
                    d'étude structure (facture finale)
                  </li>
                </ul>
                <p className="text-primary" style={{ marginTop: "10px" }}>
                  Après le paiement final, vous pourrez accéder à votre dossier
                  pour le télécharger. Si vous avez des demandes de
                  modification, vous pouvez les adresser à l'ingénieur chargé(e)
                  d'affaires via le chat interne en bas à droite.
                </p>
              </div>
            </div>

            <div className="project-step-payment__selectMethod">
              <div
                className={`project-step-choice ${
                  isSinglePaymentSelected ? "valid" : ""
                }`}
              >
                <label
                  htmlFor="single"
                  className="text-tertiary color-dark-grey"
                >
                  Régler en une seule fois
                </label>
                <input
                  type="radio"
                  id="single"
                  name="paymentOption"
                  onChange={handleSinglePaymentChange}
                  checked={isSinglePaymentSelected}
                />
              </div>
              <div
                className={`project-step-choice ${
                  isMultiplePaymentSelected ? "valid" : ""
                }`}
              >
                <label
                  htmlFor="multiple"
                  className="text-tertiary color-dark-grey"
                >
                  Régler en deux fois (sans frais)
                </label>
                <input
                  type="radio"
                  id="multiple"
                  name="paymentOption"
                  onChange={handleMultiplePaymentChange}
                  checked={isMultiplePaymentSelected}
                />
              </div>
            </div>

            {(isSinglePaymentSelected || isMultiplePaymentSelected) && (
              <div className="project-step-payment__validMethod">
                <ButtonSubmit
                  title="Valider"
                  styleButton="btn-default btn-default-primary"
                  isActive={false}
                  onClick={handleSubmit}
                  disabled={isSubmitting}
                />
              </div>
            )}
          </section>

          <PopupConfirmPaymentOption
            showPopup={showConfirmPopup}
            closeAction={handleClosePopup}
            confirmAction={handleConfirmSubmit}
            paymentType={isSinglePaymentSelected ? "single" : "multiple"}
          />
        </>
      )}
    </>
  );
};

export default ProjectStagePaymentOption;
